import React, { FC } from 'react';
import classnames from 'classnames';
import { Loader } from '../Loader';
import './Page.less';

interface PagePropsInterface {
  className?: string;
  loading?: boolean;
  inner?: boolean;
}

export const Page: FC<PagePropsInterface> = ({ children, className, loading = false, inner = false }) => {
  const loadingStyle = {
    height: 'calc(100vh - 184px)',
    overflow: 'hidden'
  };

  return (
    <div
      className={classnames(className, {
        ['contentInner']: inner
      })}
      // @ts-ignore
      style={loading ? loadingStyle : null}
    >
      {loading ? <Loader spinning /> : ''}
      {children}
    </div>
  );
};
